import { useState } from 'react'

const csrf = () => document.querySelector('meta[name="csrf-token"]')?.content || ''

// レビューのリアクション。押すとその場でカウント即更新（リロードなし）。
export default function ReactionBar({ dataset }) {
  const reviewId = dataset.reviewId
  const loggedIn = dataset.loggedIn === 'true'
  const [items, setItems] = useState(() => {
    try { return JSON.parse(dataset.reactions || '[]') } catch { return [] }
  })
  const [busy, setBusy] = useState(false)

  function toggle(kind) {
    if (!loggedIn || busy) return
    setBusy(true)
    fetch(`/reviews/${reviewId}/reactions?kind=${encodeURIComponent(kind)}`, {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrf(), Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => { if (Array.isArray(d.reactions)) setItems(d.reactions) })
      .catch(() => {})
      .finally(() => setBusy(false))
  }

  return (
    <>
      {items.map((it) => (
        <span key={it.kind} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
          <button
            type="button"
            className={'dj-react__btn' + (it.mine ? ' dj-react__btn--on' : '')}
            onClick={() => toggle(it.kind)}
            disabled={!loggedIn || busy}
            title={loggedIn ? '' : 'ログインすると押せます'}
          >
            {it.label}
          </button>
          {it.count > 0 && <span className="dj-react__n">{it.count}</span>}
        </span>
      ))}
    </>
  )
}
